<template>
    <div>
        <div v-if="loading" style="text-align:center">
            <Spinner />
        </div>
        <div v-if="tab === 1 && !loading">
            <h5>{{ type.title }}</h5>
            <div>
                <p>
                    <BaseIcon
                        name="calendar"
                        size="1x"
                        style="display:inline !important;"
                    >
                    </BaseIcon>
                    {{
                        formatDate(
                            notification.slot.start,
                            notification.slot.end
                        )
                    }}
                </p>
                <p>
                    <BaseIcon
                        name="map-marker-alt"
                        size="1x"
                        style="display:inline !important;"
                    >
                    </BaseIcon>
                    {{ type.location }}
                </p>
            </div>
            <span> {{ $t('calendar.bookModal.with') }}: </span>
            <div>
                <BaseRadio
                    :options="getParticipants()"
                    name="participant"
                    :selected="participant"
                    @input="selectParticipant"
                >
                </BaseRadio>
            </div>
            <div class="book-modal-button-wrapper">
                <BaseButton
                    id="confirmButton"
                    class="w-100"
                    variant="primary"
                    :disabled="!participant"
                    @click="handleConfirmClick"
                >
                    {{ $t('calendar.bookModal.confirm') }}
                </BaseButton>
                <!--<BaseButton-->
                <!--id="cancelButton"-->
                <!--class="w-100"-->
                <!--variant="outline-primary"-->
                <!--@click="handleCancelClick"-->
                <!--&gt;-->
                <!--{{ $t('calendar.bookModal.cancel') }}-->
                <!--</BaseButton>-->
            </div>
        </div>
        <div v-else-if="tab === 2 && !loading">
            <h5>
                {{
                    error
                        ? $t('calendar.bookModal.unknownErrorHeader')
                        : $t('calendar.bookModal.confirmationHeader')
                }}
            </h5>
            <p v-if="error">
                {{ $t('calendar.bookModal.unknownErrorBody') }}
            </p>
            <p v-else>
                {{ buildConfirmationMessage() }}
            </p>

            <div class="book-modal-button-wrapper">
                <BaseButton
                    v-if="error"
                    id="confirmButton"
                    class="w-100"
                    variant="primary"
                    @click="handleClose"
                >
                    {{ $t('calendar.bookModal.cancel') }}
                </BaseButton>
                <BaseButton
                    v-else="error"
                    id="confirmButton"
                    class="w-100"
                    variant="primary"
                    @click="handleBookingComplete"
                >
                    {{ $t('calendar.bookModal.continue') }}
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script>
// Utils
import AnalyticService from '~/services/AnalyticService';
import Spinner from '../../../../components/builders/Spinner';
import i18n from '~/i18n';

export default {
    name: 'AppointmentBookingDialog',
    components: { Spinner },
    props: {
        notification: {},
        type: {},
    },

    data() {
        return {
            participant: '',
            tab: 1,
            loading: false,
            error: '',
            participants: [],
        };
    },

    computed: {},

    methods: {
        closeDialog() {
            this.$interfaces.dialogModal.getState().resolver.res();
        },
        formatDate(from, to) {
            // This format is broken if the time span is over multiple days.
            // Blindly working off of the mockup
            let f = new Date(from);
            let t = new Date(to);
            const weekDayTexts = this.$t('general.days') || [];
            const monthTexts = this.$t('general.months') || [];

            return `${weekDayTexts[f.getDay()]} ${
                monthTexts[f.getMonth()]
            } ${f.getDate()}, ${
                f.getHours().toString().length > 1
                    ? f.getHours()
                    : '0' + f.getHours()
            }:${
                f.getMinutes().toString().length > 1
                    ? f.getMinutes()
                    : '0' + f.getMinutes()
            } - ${
                t.getHours().toString().length > 1
                    ? t.getHours()
                    : '0' + t.getHours()
            }:${
                t.getMinutes().toString().length > 1
                    ? t.getMinutes()
                    : '0' + t.getMinutes()
            }`;
        },
        getParticipants() {
            // Is there any way to lookup participant by ID here?
            return this.participants.map(participant => ({
                value: participant.sub,
                label: participant.email,
            }));
        },
        selectParticipant(value) {
            this.participant = value;
        },
        async handleConfirmClick() {
            this.loading = true;
            let postData = {
                from: this.notification.slot.start,
                to: this.notification.slot.end,
                appointmentTypeId: this.$route.params.id,
                sub: this.participant,
            };
            await this.$interfaces.calendar.event
                .post({ body: postData })
                .catch(err => {
                    console.log('Booking responded with', err.response);
                    if (err.response.status === 500) {
                        this.error = 'Please try booking another time.'; // i18n
                    } else if (
                        err.response.status >= 400 &&
                        err.response.status < 500
                    ) {
                        this.error = err.response.data[0].description;
                    }
                    this.loading = false;
                });

            // If everything went as expected, continue below, otherwise, show error msg.
            this.loading = false;
            this.tab = 2;
        },
        handleBookingComplete() {
            this.$router.push(this.$URLS.mypage);
            this.closeDialog();
        },
        handleClose() {
            this.closeDialog();
        },
        buildConfirmationMessage() {
            let confirmationMessage = `
            ${i18n.t('calendar.bookModal.emailWillBeSent')}
                 your account e-mail
                 ${i18n.t('calendar.bookModal.withConfirmation')}`;
            return confirmationMessage;
            //TODO: State account e-mail excplicitly instead of "your account e-mail"
        },
    },

    mounted() {
        //console.log('Input', this.notification);
        //console.log('Input', this.type);

        let subArray = this.notification.slot.participants.map(item => {
            return item.sub;
        });

        this.$interfaces.calendar.userinfo
            .get({
                sub: subArray,
            })
            .then(response => {
                //console.log('response', response.data);
                this.participants = response.data;
            });
    },

    watch: {},
};
</script>

<style lang="css" scoped>
.wrapper-div {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}
.book-modal-button-wrapper {
    padding:20px;
}
.book-modal-calendar-consent {
    /*margin:auto;*/
    text-align:center;
}
</style>
